import { CLEAR_ERROR, SERVER_ERROR, INVALID_ERROR, MISSING_ERROR } from '~/actions/actionTypes';

const INITIAL_STATE: any = {};

const errorReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        [action.payload.errorKey]: '',
      };
    case SERVER_ERROR:
      return {
        ...state,
        serverError: action.payload,
      };
    case INVALID_ERROR:
      return {
        ...state,
        [action.payload.componentName]: {
          ...state[action.payload.componentName],
          invalid: action.payload.message,
        },
      };
    case MISSING_ERROR:
      return {
        ...state,
        [action.payload.componentName]: {
          ...state[action.payload.componentName],
          missing: action.payload.message,
        },
      };
    default:
      return state;
  }
};

export default errorReducer;
